

const Footer = () => {
  const storeName = import.meta.env.VITE_STORE_NAME || "QYISSA";
  return (
    <footer className="bg-[#FAF8F5] text-foreground border-t border-border/60 pt-16 pb-12 font-body font-light">
      <div className="container px-4 md:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-10 md:gap-14 mb-16">
          {/* Brand */}
          <div className="space-y-4 md:pr-12">
            <img src="/logo.png" alt={storeName} className="h-10 md:h-12 object-contain" />
            <p className="text-muted-foreground text-xs leading-relaxed max-w-sm">
              A luxury lifestyle boutique brand offering premium clothing, accessories, and organic cotton essentials crafted with quiet attention to detail.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="font-display font-light text-foreground tracking-[0.2em] uppercase text-xs">QUICK LINKS</h4>
            <ul className="space-y-2 text-xs text-muted-foreground">
              {[
                { label: "Home", href: "/" },
                { label: "All Products", href: "/products" },
                { label: "Our Story", href: "/about" },
              ].map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="hover:text-foreground transition-colors uppercase tracking-[0.15em]">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

        </div>

        <div className="border-t border-border/40 pt-8 text-center text-[10px] sm:text-xs text-muted-foreground flex flex-col md:flex-row justify-between items-center gap-2 uppercase tracking-[0.2em]">
          <p>© {new Date().getFullYear()} {storeName}. ALL RIGHTS RESERVED.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
